import script from "./TopicView.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicView.vue?vue&type=script&setup=true&lang=js"

import "./TopicView.vue?vue&type=style&index=0&id=7d63b744&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d63b744"]])

export default __exports__